import pickBy from 'lodash/pickBy';
import { pick } from 'lodash/fp';

import config from '@config';

import createDataSource from '../createDataSource';
import { getDefaultEmptyList, getDefaultListHandler } from '../utils';

const BASE_PATHNAME = 'emails';

export default () => {
  const dataSource = createDataSource(`${config.api.url}`);

  const getById = ({ id }) => dataSource.get(`${BASE_PATHNAME}/${id}`).json();
  const getByIds = ({ ids }) => Promise.all(ids.map((id) => getById({ id })));

  const create = ({ values: json }) => dataSource.post(`${BASE_PATHNAME}`, { json }).json();
  const update = ({ id, values }) => dataSource.put(`${BASE_PATHNAME}`, { json: { ...values, id } }).json();

  const remove = ({ id }) => dataSource.delete(`${BASE_PATHNAME}/${id}`);

  const createOrUpdate = ({ id, values }) => (id ? update({ id, values }) : create({ values }));

  const send = async ({ id, values, dateTime }) => {
    const email = await createOrUpdate({ id, values });
    return dataSource.put(`${BASE_PATHNAME}/${email.id}/send`, { searchParams: pickBy({ dateTime }) });
  };

  const test = async ({ id, emails }) => {
    return dataSource.put(`${BASE_PATHNAME}/${id}/send-test`, { json: emails });
  };

  const duplicate = ({ id }) => dataSource.post(`${BASE_PATHNAME}/${id}/duplicate`);

  const audiencesList = () => dataSource.get(`${BASE_PATHNAME}/audience-lists`);

  return {
    audiencesList,

    getList: getDefaultListHandler({
      url: BASE_PATHNAME,
      dataSource,
      transformFilter: pick(['status', 'eventId']),
    }),

    getById,

    getByIds,

    remove,

    create,

    update,

    send,

    test,

    duplicate,

    getEmptyList: getDefaultEmptyList,
  };
};
